import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import XNumberInput from '../../../../packages/kiti/components/form/NumberInput'

const BuyInfoSection = () => {
  const { t } = useTranslation('editStocks')
  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('sections.buyInfo')}
      </Title>
      <Line />
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.purchasePrice')} field="purchasePrice" Input={XNumberInput} />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.purchaseTax')} field="purchaseTax" Input={XNumberInput} />
        </Col>

        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.currency')} field="currency" />
        </Col>
      </Grid>
    </>
  )
}

export default BuyInfoSection
